/* Extracted from snippets/sticky-cart.liquid - pure JS, no Liquid
   interpolation, safe to load as a deferred external file. Browser
   caches across PDP visits; previously inlined 49 KB on every PDP. */
function initAlasilStickyCart() {
  const sticky = document.getElementById("sticky-cart");
  /* Remove the first-paint `display: none` set inline on the div so the
     CSS-driven opacity/transform show-hide animation can take over.
     Element starts visible-in-flex but opacity:0 + translateY(120%) (set
     by the .sticky-cart CSS rule), and the .sticky-cart--no-transition
     class - also set inline at render - suppresses the slide animation
     for this first frame so we don't see it animate in from nowhere
     when the cart eventually adds .active. */
  if (sticky) {
    sticky.style.removeProperty('display');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sticky.classList.remove('sticky-cart--no-transition');
      });
    });
  }
  // Publish the occupied bottom space independently of the slide animation.
  // Rashid can then sit just above compact and full-height purchase bars.
  if (sticky && !sticky._rashidOffsetObserver) {
    const syncSupportOffset = (entries) => {
      const support = document.getElementById('wa-widget');
      if (!support) return;
      const entry = Array.isArray(entries) && entries.find((item) => item.target === sticky);
      const box = entry && entry.borderBoxSize;
      const size = box && (Array.isArray(box) ? box[0] : box);
      const height = size && Number.isFinite(size.blockSize) ? size.blockSize : sticky.offsetHeight;
      // CSS owns the responsive bottom inset (including the safe area).
      // Resolving computed bottom here could force another style/layout update.
      const offset = 'calc(var(--pdp-purchasebar-bottom, 64px) + ' + Math.ceil(height) + 'px + 8px)';
      // Only Rashid consumes this value. Writing an inherited property on the
      // root invalidated styles throughout the PDP for every bar resize.
      if (support.style.getPropertyValue('--pdp-support-bottom') !== offset) {
        support.style.setProperty('--pdp-support-bottom', offset);
      }
    };
    sticky._rashidOffsetObserver = new ResizeObserver(syncSupportOffset);
    sticky._rashidOffsetObserver.observe(sticky);
    window.addEventListener('resize', syncSupportOffset, { passive: true });
    // ResizeObserver delivers the initial size after normal layout. Measuring
    // immediately after removing display:none forced an extra startup layout.
  }
  const stickyBtn = document.getElementById("sticky-cart-btn");

  // Find the main product page form button, not product cards
  // Priority: form inside MainProduct section > form inside product-form component > fallback
  let atcButton = null;
  
  // First, try to find form in MainProduct section (most specific)
  const mainProductSection = document.querySelector('[id^="MainProduct-"]');
  if (mainProductSection) {
    const mainProductForm = mainProductSection.querySelector('form[data-type="add-to-cart-form"]');
    if (mainProductForm) {
      atcButton = mainProductForm.querySelector('button[type="submit"][name="add"]') ||
                  mainProductForm.querySelector('button[type="submit"]') ||
                  mainProductForm.querySelector('.product-form__submit');
    }
  }
  
  // If not found, try product-form component (but exclude product cards)
  if (!atcButton) {
    const productFormComponents = document.querySelectorAll('product-form.product-form');
    for (const productForm of productFormComponents) {
      // Skip if it's inside a product card
      if (productForm.closest('.card-product, .card-wrapper, [class*="card"], [class*="product-card"]')) {
        continue;
      }
      const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        atcButton = form.querySelector('button[type="submit"][name="add"]') ||
                    form.querySelector('button[type="submit"]') ||
                    form.querySelector('.product-form__submit');
        if (atcButton) break;
      }
    }
  }
  
  // Last resort: find any form with data-type="add-to-cart-form" but exclude product cards
  if (!atcButton) {
    const allForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (const form of allForms) {
      // Skip if inside a product card
      if (form.closest('.card-product, .card-wrapper, [class*="card"], [class*="product-card"]')) {
        continue;
      }
      atcButton = form.querySelector('button[type="submit"][name="add"]') ||
                  form.querySelector('button[type="submit"]') ||
                  form.querySelector('.product-form__submit');
      if (atcButton) break;
    }
  }

  if (!sticky || !stickyBtn) return;

  let isSmartBundleInView = document.body.classList.contains('smart-bundle-in-view');

  // Find threshold element (form or button to determine when to show sticky cart)
  // Even if ATC button not found (sold out), use the product form or info section
  const atcForm = atcButton ? atcButton.closest("form") : null;
  const productForm = document.querySelector('product-form.product-form form, form[data-type="add-to-cart-form"]');
  const productInfo = document.querySelector('product-info, .product__info-wrapper, .product-form');
  let thresholdElement = atcForm || productForm || productInfo || sticky;

  // Helper function to find ATC button (used after variant changes)
  const findAtcButton = () => {
    const mainProductSection = document.querySelector('[id^="MainProduct-"]');
    if (mainProductSection) {
      const mainProductForm = mainProductSection.querySelector('form[data-type="add-to-cart-form"]');
      if (mainProductForm) {
        return mainProductForm.querySelector('button[type="submit"][name="add"]') ||
               mainProductForm.querySelector('button[type="submit"]') ||
               mainProductForm.querySelector('.product-form__submit');
      }
    }
    return null;
  };

  // Helper function to find threshold element (used for AJAX navigation)
  const findThresholdElement = () => {
    const mainProductSection = document.querySelector('[id^="MainProduct-"]');
    if (mainProductSection) {
      const form = mainProductSection.querySelector('form[data-type="add-to-cart-form"]');
      if (form) return form;
      const productFormEl = mainProductSection.querySelector('product-form.product-form form');
      if (productFormEl) return productFormEl;
    }
    const currentAtcForm = atcButton ? atcButton.closest("form") : null;
    const currentProductForm = document.querySelector('product-form.product-form form, form[data-type="add-to-cart-form"]');
    const currentProductInfo = document.querySelector('product-info, .product__info-wrapper, .product-form');
    return currentAtcForm || currentProductForm || currentProductInfo || sticky;
  };

  // Reuse the CSS breakpoint without forcing viewport geometry after mutations.
  const mobileViewport = window.matchMedia('(max-width: 767px)');
  const isMobileView = () => mobileViewport.matches;
  
  // ========================================
  // INTERSECTION OBSERVER for ATC Button visibility
  // More reliable than scroll-based threshold calculation
  // ========================================
  let isAtcButtonVisible = true; // Assume visible initially
  let atcObserver = null;
  let toggleDebounceTimer = null;
  let observerReady = false; // Prevent flash on initial setup
  
  // Debounced toggle to prevent rapid show/hide flashing
  const debouncedToggleSticky = (immediate = false) => {
    if (toggleDebounceTimer) {
      clearTimeout(toggleDebounceTimer);
    }
    
    if (immediate) {
      toggleSticky();
      return;
    }
    
    // Small delay to stabilize state changes
    toggleDebounceTimer = setTimeout(() => {
      toggleSticky();
    }, 50);
  };
  
  const setupAtcObserver = () => {
    // Disconnect previous observer if exists
    if (atcObserver) {
      atcObserver.disconnect();
    }
    
    // Re-find ATC button (might have changed after variant change)
    const currentAtcButton = findAtcButton() || atcButton;
    
    // If no ATC button found (e.g., sold out product), observe the product form instead
    // This ensures sticky cart shows for sold out products too
    let elementToObserve = currentAtcButton;
    
    if (!elementToObserve) {
      // Find a fallback inside the PDP purchase UI. Do not use a bare `.wa-btn`:
      // the global WhatsApp support widget shares that class and is fixed to the
      // viewport, which would prevent the desktop sticky cart from ever opening.
      const mainProductSection = document.querySelector('[id^="MainProduct-"]');
      if (mainProductSection) {
        // The sold-out WhatsApp CTA is already contained by `.soldout-wrap`.
        elementToObserve = mainProductSection.querySelector('.soldout-wrap') ||
                          mainProductSection.querySelector('.product-form__buttons') ||
                          mainProductSection.querySelector('.product-form') ||
                          mainProductSection.querySelector('.buy-buttons') ||
                          mainProductSection.querySelector('product-form') ||
                          mainProductSection.querySelector('.product__info-wrapper');
      }
      
      // Global fallback
      if (!elementToObserve) {
        elementToObserve = document.querySelector('.soldout-wrap') ||
                          document.querySelector('.product-form__buttons') ||
                          document.querySelector('.product-form') ||
                          document.querySelector('.buy-buttons') ||
                          document.querySelector('product-form') ||
                          document.querySelector('.product__info-wrapper');
      }
    }
    
    // Still no element found - show sticky on mobile, hide on desktop
    if (!elementToObserve) {
      isAtcButtonVisible = !isMobileView();
      debouncedToggleSticky(true);
      return;
    }
    
    // Update the atcButton reference if we found an actual button
    if (currentAtcButton) {
      atcButton = currentAtcButton;
    }
    
    // Reset ready flag during setup
    observerReady = false;
    
    // Create new IntersectionObserver
    atcObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const wasVisible = isAtcButtonVisible;
        // Element is visible if ANY part of it is in viewport
        isAtcButtonVisible = entry.isIntersecting;
        
        // Skip the initial callback to prevent flash
        if (!observerReady) {
          observerReady = true;
          // Only toggle if state actually requires showing sticky
          // (element is NOT visible and we're not on mobile)
          if (!isAtcButtonVisible && !isMobileView()) {
            debouncedToggleSticky(true);
          }
          return;
        }
        
        // Only toggle if visibility actually changed
        if (wasVisible !== isAtcButtonVisible) {
          debouncedToggleSticky();
        }
      });
    }, {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0 // trigger as soon as even 1px is visible/hidden
    });
    
    atcObserver.observe(elementToObserve);
  };
  
  // Observer starts after toggleSticky is initialized below.

  // ========================================
  // STICKY CART VARIANT SYNC
  // Updates sticky cart UI when variant changes
  // ========================================
  
  // Get sticky cart variant data
  function getStickyCartData() {
    const script = document.getElementById('sticky-cart-variants');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('Error parsing sticky cart variant data:', e);
      return null;
    }
  }
  
  let stickyCartData = getStickyCartData();

  let stickyBadgeSyncSequence = 0;

  /**
   * PDP "In your cart" badge (#PdpInCartBadge-sticky). Uses the storefront-wide
   * cart snapshot cache so inline, sticky, header, and AppleCare consumers do not
   * race independent cart.js reads during mount or variant changes.
   */
  const syncPdpInCartStickyBadge = (variantId, cartState) => {
    const badge = document.getElementById('PdpInCartBadge-sticky');
    if (!badge) return;
    const sequence = ++stickyBadgeSyncSequence;

    let id =
      variantId != null && variantId !== ''
        ? parseInt(String(variantId), 10)
        : NaN;
    if (isNaN(id)) {
      const main = document.querySelector('[id^="MainProduct-"]');
      const inp = main && (main.querySelector('form input[name="id"]') || main.querySelector('form select[name="id"]'));
      if (inp && inp.value) id = parseInt(inp.value, 10);
    }
    if (isNaN(id)) {
      badge.hidden = true;
      badge.setAttribute('aria-hidden', 'true');
      return;
    }

    const root =
      (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartUrl = (root.endsWith('/') ? root : root + '/') + 'cart.js';

    const applyCartState = (cart) => {
      const items = (cart && cart.items) || [];
      let inCart = false;
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        const vid = parseInt(it.variant_id, 10);
        const qty = parseInt(it.quantity, 10) || 0;
        if (vid === id && qty > 0) {
          inCart = true;
          break;
        }
      }
      badge.hidden = !inCart;
      badge.setAttribute('aria-hidden', inCart ? 'false' : 'true');
    };

    if (cartState && Array.isArray(cartState.items)) {
      applyCartState(cartState);
      return;
    }

    const cartPromise = typeof window.getCartSnapshot === 'function'
      ? window.getCartSnapshot()
      : fetch(cartUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then((response) => response.ok ? response.json() : null);
    Promise.resolve(cartPromise)
      .then((cart) => {
        if (sequence !== stickyBadgeSyncSequence || !cart) return;
        applyCartState(cart);
      })
      .catch(() => {});
  };

  document.addEventListener('cart:updated', (event) => {
    const cartState = event && event.detail && event.detail.cart;
    syncPdpInCartStickyBadge(null, cartState);
    schedulePdpAppleCareSync();
  });

  document.addEventListener('applecare:cart-selection', (event) => {
    const detail = event.detail || {};
    const input = document.querySelector('[data-applecare-input]');
    const deviceVariantId = parseInt(sticky.dataset.currentVariantId, 10);

    if (
      !input ||
      parseInt(input.value, 10) !== parseInt(detail.appleCareVariantId, 10) ||
      deviceVariantId !== parseInt(detail.parentVariantId, 10)
    ) {
      return;
    }

    const checked = Boolean(detail.selected);
    if (input.checked === checked) return;

    setPdpAppleCareChecked(input, checked);
  });
  
  // One committed server-rendered purchase update for products and variants.
  document.addEventListener('alasil:purchase-updated', () => {
    // Re-read the new product's variant data
    stickyCartData = getStickyCartData();
    
    if (!stickyCartData) return;
    
    // Re-find the add to cart button (old one is removed)
    const mainProductSection = document.querySelector('[id^="MainProduct-"]');
    if (mainProductSection) {
      atcButton = mainProductSection.querySelector('product-form.product-form button[type="submit"]') ||
                  mainProductSection.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]') ||
                  mainProductSection.querySelector('.product-form__submit');
    }
    
    // IMPORTANT: Re-setup IntersectionObserver for the new ATC button
    // This fixes the bug where sticky cart shows when ATC button is still visible
    thresholdElement = findThresholdElement();
    
    // Re-setup observer after a small delay to ensure DOM is settled
    setTimeout(() => {
      setupAtcObserver();
    }, 100);
    
    // Get current variant from the new product
    // ES5-safe access (was `variantInput?.value` / `stickyCartData.variants?.[id]`)
    // - older Chrome Mobile / WebView builds throw "Unexpected token ." on
    // optional chaining and the entire <script> block aborts, killing the
    // sticky cart on the PDP. Use logical-AND chains instead.
    const variantInput = mainProductSection && (
      mainProductSection.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      mainProductSection.querySelector('product-form input[name="id"]') ||
      mainProductSection.querySelector('input[name="id"]')
    );
    const currentVariantId = variantInput && variantInput.value;

    if (currentVariantId && stickyCartData.variants && stickyCartData.variants[currentVariantId]) {
      updateStickyCartForVariant(stickyCartData.variants[currentVariantId]);
    }
    syncPdpInCartStickyBadge(currentVariantId);
    schedulePdpAppleCareSync(50);
    
    // Update product title
    const titleEl = sticky.querySelector('.sticky-cart__title');
    if (titleEl && stickyCartData.productTitle) {
      titleEl.textContent = stickyCartData.productTitle;
    }
    
    // Update product image
    const imgEl = document.getElementById('sticky-cart-img');
    if (imgEl && stickyCartData.productFeaturedImage) {
      imgEl.src = stickyCartData.productFeaturedImage;
      imgEl.alt = stickyCartData.productTitle || '';
    }
  });
  
  // Elements to update
  const stickyImg = document.getElementById('sticky-cart-img');
  const stickyPriceRow = document.getElementById('sticky-cart-price-row');
  const stickyPrice = document.getElementById('sticky-cart-price');
  const stickyComparePrice = document.getElementById('sticky-cart-compare-price');
  const stickyDiscount = document.getElementById('sticky-cart-discount');
  const stickyAppleCareIcon = document.getElementById('sticky-cart-applecare-icon');
  const stickyAppleCareLabel = document.getElementById('sticky-cart-applecare-label');
  const stickyBtnText = document.getElementById('sticky-cart-btn-text');
  const stickyQtyWrapper = document.getElementById('sticky-cart-qty-wrapper');
  let stickyWaBtn = document.getElementById('sticky-cart-wa-btn'); // let - may be updated dynamically
  
  // Quantity elements (declared early for use in updateStickyCartForVariant)
  const qtyInput = document.getElementById("sticky-qty-input");
  const qtyMinus = document.getElementById("sticky-qty-minus");
  const qtyPlus = document.getElementById("sticky-qty-plus");
  const mainQtyInput = document.querySelector('.product-form__quantity .quantity__input, quantity-input .quantity__input');
  
  const minQty = 1;
  let maxQty = (qtyInput && parseInt(qtyInput.max)) || 99;
  if (maxQty <= 0) maxQty = 99;
  
  // Define quantity helper functions early (hoisted)
  function updateQtyButtonStates(qty) {
    if (!qtyMinus || !qtyPlus) return;
    qtyMinus.disabled = qty <= minQty;
    qtyPlus.disabled = qty >= maxQty;
  }
  
  function updateMaxQty(newMax) {
    maxQty = newMax > 0 ? newMax : 99;
    if (qtyInput) qtyInput.max = maxQty;
    updateQtyButtonStates(parseInt(qtyInput && qtyInput.value) || 1);
  }
  
  function updateStickyQuantity(newValue) {
    if (!qtyInput) return;
    const qty = Math.max(minQty, Math.min(maxQty, newValue));
    qtyInput.value = qty;
    
    // Add bump animation
    qtyInput.classList.remove('bump');
    void qtyInput.offsetWidth; // Force reflow
    qtyInput.classList.add('bump');
    
    // Update button states
    updateQtyButtonStates(qty);
    
    // Sync with main product form
    if (mainQtyInput) {
      mainQtyInput.value = qty;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  // Currency icon SVGs (Dirham symbol) reference the sprite rendered once at
  // the top of <body>. Keep each client-rendered version identical to its
  // server-rendered Liquid markup so price updates cannot cause layout shift.
  const mainPriceCurrencyIconSVG = '<span aria-hidden="true" style="display:inline-block; line-height:1; margin-right:0.15em;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 870" style="width:1em; height:1em; vertical-align:middle;"><use href="#alasil-currency-aed"/></svg></span> ';
  const stickyPriceCurrencyIconSVG = '<span aria-hidden="true" style="display:inline-flex; align-items:center; line-height:1;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 870" style="width:1em; height:1em;"><use href="#alasil-currency-aed"/></svg></span>';
  
  // Format price (number only, e.g., "4,959")
  function formatPrice(cents) {
    const value = parseInt(cents) / 100;
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  
  // Use surface-specific markup to preserve the initial server layout.
  function formatMainPriceWithCurrency(cents) {
    return mainPriceCurrencyIconSVG + formatPrice(cents);
  }

  function formatStickyPriceWithCurrency(cents) {
    return stickyPriceCurrencyIconSVG + formatPrice(cents);
  }
  
  // Format price without currency symbol (for compare-at price)
  function formatPriceNoCurrency(cents) {
    const value = parseInt(cents) / 100;
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function getSelectedAppleCare() {
    const input = document.querySelector('[data-applecare-input]');
    if (!input || !input.checked) return null;

    const fallback = stickyCartData && stickyCartData.appleCare;
    return {
      price: parseInt(input.dataset.applecarePrice, 10) || (fallback && fallback.price) || 0,
      title: input.dataset.applecareTitle || (fallback && fallback.title) || 'AppleCare+',
      image: input.dataset.applecareImage || (fallback && fallback.image) || null
    };
  }

  function renderMainProductPrice(variant, addonPrice) {
    if (!variant) return;

    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (!mainProduct) return;

    const priceRoots = mainProduct.querySelectorAll('.mainp-price[id^="price-"]');
    if (!priceRoots.length) return;

    const displayPrice = variant.price + addonPrice;
    const displayCompareAtPrice = variant.compareAtPrice
      ? variant.compareAtPrice + addonPrice
      : null;
    const onSale = displayCompareAtPrice && displayCompareAtPrice > displayPrice;

    priceRoots.forEach((priceRoot) => {
      const salePrice = priceRoot.querySelector('.price__sale .price-item--sale');
      const regularPrice = priceRoot.querySelector('.price__regular .price-item--regular');
      const comparePrice = priceRoot.querySelector('.price-item--compare, .mainp-price-item--compare');

      if (salePrice) {
        salePrice.innerHTML = formatMainPriceWithCurrency(displayPrice);
      } else if (regularPrice) {
        regularPrice.innerHTML = formatMainPriceWithCurrency(displayPrice);
      }

      if (comparePrice && onSale) {
        comparePrice.textContent = formatPriceNoCurrency(displayCompareAtPrice);
      }

      const discountBadge = priceRoot.querySelector('.percent__badge-sale');
      if (discountBadge && onSale) {
        const discountPercent = Math.max(1, Math.round(
          ((displayCompareAtPrice - displayPrice) * 100) / displayCompareAtPrice
        ));
        if (discountPercent >= 1) {
          discountBadge.textContent = discountPercent + '% ' + (discountBadge.dataset.discountSuffix || 'OFF');
        }
      }
    });
  }

  let appleCareCartSyncTimer = null;
  let appleCareCartSyncToken = 0;
  let appleCarePdpMutation = Promise.resolve();

  function setPdpAppleCareChecked(input, checked) {
    input.dataset.applecareCartSync = '1';
    input.checked = checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    delete input.dataset.applecareCartSync;
  }

  function getCartSections(cartElement) {
    if (!cartElement || typeof cartElement.getSectionsToRender !== 'function') {
      return 'cart-drawer,cart-icon-bubble';
    }

    return cartElement.getSectionsToRender().map((section) => section.id).join(',')
      || 'cart-drawer,cart-icon-bubble';
  }

  function getParentKey(item) {
    if (!item || !item.parent_relationship) return null;
    return item.parent_relationship.parent_key
      || (
        item.parent_relationship.parent
        && item.parent_relationship.parent.key
      )
      || null;
  }

  function reconcilePdpAppleCareDrawer(cartState, input, deviceVariantId, appleCareVariantId) {
    const items = (cartState && cartState.items) || [];
    const parentLine = items.find((item) => (
      parseInt(item.variant_id, 10) === deviceVariantId
      && !item.parent_relationship
      && parseInt(item.quantity, 10) > 0
    ));
    if (!parentLine) return;

    const childLine = items.find((item) => (
      parseInt(item.variant_id, 10) === appleCareVariantId
      && parseInt(item.quantity, 10) > 0
      && getParentKey(item) === parentLine.key
    ));
    const isAdded = Boolean(childLine);

    if (input.checked !== isAdded) {
      setPdpAppleCareChecked(input, isAdded);
    }

    const appleCareContainers = document.querySelectorAll(
      '.cart-item__applecare[data-ac-variant]'
    );
    appleCareContainers.forEach((container) => {
      if (
        parseInt(container.dataset.acVariant, 10) !== appleCareVariantId
        || container.dataset.parentKey !== parentLine.key
      ) {
        return;
      }

      container.classList.toggle('is-added', isAdded);
      container.classList.toggle('is-offer', !isAdded);
      const removeButton = container.querySelector('[data-applecare-remove]');
      if (removeButton) {
        removeButton.dataset.lineKey = childLine ? childLine.key : '';
      }
    });

    const drawerTotal = document.querySelector('.cart-footer__total-value');
    if (drawerTotal && Number.isFinite(cartState.total_price)) {
      drawerTotal.textContent = formatPrice(cartState.total_price);
    }

    const drawerTitle = document.getElementById('cartDrawerStepTitle');
    if (drawerTitle && Number.isFinite(cartState.item_count)) {
      drawerTitle.textContent = drawerTitle.textContent.replace(
        /\(\d+\)/,
        '(' + cartState.item_count + ')'
      );
    }

    if (Number.isFinite(cartState.item_count)) {
      document.querySelectorAll(
        '#cart-icon-bubble .wbhcartitem, #cart-icon-bubble .header__cart-count'
      ).forEach((count) => {
        count.textContent = cartState.item_count;
        count.classList.toggle('hidden', cartState.item_count === 0);
      });
    }
  }

  async function persistPdpAppleCareSelection(input, checked) {
    if (!input || input.dataset.applecareCartSync === '1') return;

    const deviceVariantId = parseInt(sticky.dataset.currentVariantId, 10);
    const appleCareVariantId = parseInt(input.value, 10);
    if (!deviceVariantId || !appleCareVariantId) return;

    const appleCareCard = input.closest('[data-applecare]');
    input.disabled = true;
    if (appleCareCard) appleCareCard.setAttribute('aria-busy', 'true');

    const root = (
      typeof window.Shopify !== 'undefined'
      && window.Shopify.routes
      && window.Shopify.routes.root
    ) || '/';
    const cartUrl = (root.endsWith('/') ? root : root + '/') + 'cart.js';

    try {
      const cartState = typeof window.getCartSnapshot === 'function'
        ? await window.getCartSnapshot()
        : await fetch(cartUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then((response) => response.ok ? response.json() : null);
      if (!cartState) throw new Error('Unable to read cart');
      const items = (cartState && cartState.items) || [];
      const parentLines = items.filter((item) => (
        parseInt(item.variant_id, 10) === deviceVariantId
        && !item.parent_relationship
        && parseInt(item.quantity, 10) > 0
      ));

      // If the device is not in the cart yet, keep the choice local. The
      // product form adds the device and AppleCare together on Add to Cart.
      if (!parentLines.length) return;

      const parentKeys = new Set(parentLines.map((item) => item.key));
      const childLine = items.find((item) => (
        parseInt(item.variant_id, 10) === appleCareVariantId
        && parseInt(item.quantity, 10) > 0
        && parentKeys.has(getParentKey(item))
      ));

      if ((checked && childLine) || (!checked && !childLine)) return;

      const cartElement = document.querySelector('cart-drawer')
        || document.querySelector('cart-notification');
      const sections = getCartSections(cartElement);
      const baseUrl = checked
        ? ((window.routes && window.routes.cart_add_url) || '/cart/add')
        : ((window.routes && window.routes.cart_change_url) || '/cart/change');
      const endpoint = baseUrl.endsWith('.js') ? baseUrl : baseUrl + '.js';
      const body = checked
        ? {
            items: [{
              id: appleCareVariantId,
              quantity: parseInt(parentLines[0].quantity, 10) || 1,
              parent_line_key: parentLines[0].key
            }],
            sections,
            sections_url: window.location.pathname
          }
        : {
            id: childLine.key,
            quantity: 0,
            sections,
            sections_url: window.location.pathname
          };

      if (typeof window.invalidateCartSnapshot === 'function') window.invalidateCartSnapshot();
      const mutationResponse = await window.cartMutationFetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });
      const mutationData = await mutationResponse.json();
      if (!mutationResponse.ok || mutationData.status) {
        throw new Error(mutationData.description || 'Unable to update AppleCare');
      }

      let renderedSections = mutationData.sections;
      let renderedCart = mutationData;
      if (cartElement) {
        const verifiedCart = typeof window.getCartSnapshot === 'function'
          ? await window.getCartSnapshot({ force: true })
          : await fetch(cartUrl, {
              cache: 'no-store',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            }).then((response) => response.ok ? response.json() : null);
        if (verifiedCart) renderedCart = verifiedCart;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: renderedCart
        });
      }

      if (
        cartElement
        && typeof cartElement.renderContents === 'function'
        && renderedSections
      ) {
        cartElement.renderContents(Object.assign({}, renderedCart, {
          sections: renderedSections,
          skipDrawerOpen: true
        }));
      }
      reconcilePdpAppleCareDrawer(
        renderedCart,
        input,
        deviceVariantId,
        appleCareVariantId
      );
      schedulePdpAppleCareSync(50);
    } catch (error) {
      if (input.checked === checked) {
        setPdpAppleCareChecked(input, !checked);
      }
      console.error('AppleCare cart update failed:', error);
    } finally {
      input.disabled = false;
      if (appleCareCard) appleCareCard.removeAttribute('aria-busy');
    }
  }

  function schedulePdpAppleCareSync(delay) {
    clearTimeout(appleCareCartSyncTimer);
    appleCareCartSyncTimer = setTimeout(syncPdpAppleCareFromCart, delay || 0);
  }

  async function syncPdpAppleCareFromCart() {
    const input = document.querySelector('[data-applecare-input]');
    if (!input || !input.value || input.disabled) return;

    const deviceVariantId = parseInt(sticky.dataset.currentVariantId, 10);
    const appleCareVariantId = parseInt(input.value, 10);
    if (!deviceVariantId || !appleCareVariantId) return;

    const token = ++appleCareCartSyncToken;
    const root = (
      typeof window.Shopify !== 'undefined' &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';
    const cartUrl = (root.endsWith('/') ? root : root + '/') + 'cart.js';

    try {
      const cart = typeof window.getCartSnapshot === 'function'
        ? await window.getCartSnapshot()
        : await fetch(cartUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then((response) => response.ok ? response.json() : null);
      if (!cart) return;
      if (token !== appleCareCartSyncToken) return;

      const items = (cart && cart.items) || [];
      const deviceKeys = new Set();
      items.forEach((item) => {
        if (
          parseInt(item.variant_id, 10) === deviceVariantId &&
          !item.parent_relationship &&
          parseInt(item.quantity, 10) > 0
        ) {
          deviceKeys.add(item.key);
        }
      });

      const appleCareIsInCart = items.some((item) => {
        if (
          parseInt(item.variant_id, 10) !== appleCareVariantId ||
          parseInt(item.quantity, 10) <= 0 ||
          !item.parent_relationship
        ) {
          return false;
        }

        const parentKey =
          item.parent_relationship.parent_key ||
          (
            item.parent_relationship.parent &&
            item.parent_relationship.parent.key
          );
        return parentKey && deviceKeys.has(parentKey);
      });

      // The linked-options flow can replace the PDP form while cart.js is in
      // flight. Only update the same checkbox/AppleCare variant we queried.
      const currentInput = document.querySelector('[data-applecare-input]');
      if (
        currentInput !== input ||
        parseInt(currentInput.value, 10) !== appleCareVariantId ||
        currentInput.disabled
      ) {
        return;
      }

      if (currentInput.checked !== appleCareIsInCart) {
        setPdpAppleCareChecked(currentInput, appleCareIsInCart);
      }
    } catch (error) {
      // Keep the current local choice on transient network errors. The next
      // cart update, drawer render or linked-product load retries the sync.
    }
  }

  function renderStickyPrice(variant) {
    if (!variant) return;

    const appleCare = getSelectedAppleCare();
    const addonPrice = appleCare ? appleCare.price : 0;
    const displayPrice = variant.price + addonPrice;
    const displayCompareAtPrice = variant.compareAtPrice
      ? variant.compareAtPrice + addonPrice
      : null;
    const onSale = displayCompareAtPrice && displayCompareAtPrice > displayPrice;

    renderMainProductPrice(variant, addonPrice);

    sticky.classList.toggle('is-applecare-selected', Boolean(appleCare));
    if (stickyAppleCareIcon) {
      stickyAppleCareIcon.hidden = !appleCare;
      const image = stickyAppleCareIcon.querySelector('img');
      if (image && appleCare && appleCare.image) image.src = appleCare.image;
    }
    if (stickyAppleCareLabel) {
      stickyAppleCareLabel.hidden = !appleCare;
      const title = stickyAppleCareLabel.querySelector('span');
      if (title && appleCare) title.textContent = appleCare.title;
    }

    if (stickyPrice) {
      stickyPrice.classList.add('updating');
      requestAnimationFrame(() => {
        stickyPrice.innerHTML = formatStickyPriceWithCurrency(displayPrice);
        stickyPrice.classList.toggle('sticky-cart__price--sale', onSale);
        requestAnimationFrame(() => stickyPrice.classList.remove('updating'));
      });
    }

    if (stickyComparePrice) {
      if (onSale) {
        stickyComparePrice.textContent = formatPriceNoCurrency(displayCompareAtPrice);
        stickyComparePrice.style.display = '';
      } else {
        stickyComparePrice.style.display = 'none';
      }
    }

    if (stickyDiscount) {
      const discountPercent = onSale && variant.available
        ? Math.max(1, Math.round((displayCompareAtPrice - displayPrice) / displayCompareAtPrice * 100))
        : 0;
      if (discountPercent >= 1) {
        stickyDiscount.textContent = '-' + discountPercent + '%';
        stickyDiscount.style.display = '';
      } else {
        stickyDiscount.style.display = 'none';
      }
    }
  }

  // Update sticky cart UI for new variant
  function updateStickyCartForVariant(variant) {
    if (!variant || !stickyCartData) return;

    // Update current variant ID on sticky cart element
    sticky.dataset.currentVariantId = variant.id;

    // Update image
    if (stickyImg) {
      const newImgSrc = variant.featuredImage || stickyCartData.productFeaturedImage;
      if (newImgSrc && stickyImg.src !== newImgSrc) {
        stickyImg.src = newImgSrc;
      }
    }

    renderStickyPrice(variant);
    
    // Update availability state
    if (variant.available) {
      // Variant is available - show ATC button
      stickyBtn.style.display = '';
      stickyBtn.disabled = false;
      stickyBtn.classList.remove('sticky-cart__btn--disabled');
      if (stickyBtnText) {
        stickyBtnText.textContent = variant.addToCartText || stickyCartData.addToCartText;
      }
      // Show quantity controls
      if (stickyQtyWrapper) {
        stickyQtyWrapper.style.display = '';
      }
      // Show price row
      if (stickyPriceRow) {
        stickyPriceRow.style.display = '';
      }
      // Hide WhatsApp button
      if (stickyWaBtn) {
        stickyWaBtn.style.display = 'none';
      }
    } else {
      // Variant is sold out - show WhatsApp button
      stickyBtn.style.display = 'none';
      stickyBtn.disabled = true;
      
      // Hide quantity controls
      if (stickyQtyWrapper) {
        stickyQtyWrapper.style.display = 'none';
      }
      // Hide price row
      if (stickyPriceRow) {
        stickyPriceRow.style.display = 'none';
      }
      
      // Show WhatsApp button (already exists in HTML, just show it)
      if (stickyWaBtn) {
        // Update WA URL with variant info and SKU
        const variantTitle = variant.options
          ? variant.options.filter((value) => value && value !== 'Default Title').join(' / ')
          : '';
        const productTitle = stickyCartData.productTitle || '';
        const fullTitle = variantTitle ? productTitle + ' - ' + variantTitle : productTitle;
        const sku = variant.sku || '';
        const skuPart = sku ? ' (SKU: ' + sku + ')' : '';
        const waMessage = encodeURIComponent("Hi, I'm interested in " + fullTitle + skuPart + ". Can you check the availability?");
        const waNumber = stickyCartData.whatsappNumber || '97142885680';
        stickyWaBtn.href = 'https://wa.me/' + waNumber + '?text=' + waMessage;
        stickyWaBtn.style.display = '';
      }
    }
    
    // Update max quantity
    const newMax = variant.inventoryPolicy === 'continue' ? 99 : (variant.inventoryQuantity || 99);
    updateMaxQty(newMax);
    
    // Reset quantity to 1 when variant changes
    if (qtyInput) {
      qtyInput.value = 1;
      updateQtyButtonStates(1);
    }
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-applecare-input]')) return;
    const variantId = sticky.dataset.currentVariantId;
    const variant = stickyCartData && stickyCartData.variants && stickyCartData.variants[variantId];
    if (variant) renderStickyPrice(variant);

    if (event.target.dataset.applecareCartSync === '1') return;
    const checked = event.target.checked;
    appleCarePdpMutation = appleCarePdpMutation.then(() => (
      persistPdpAppleCareSelection(event.target, checked)
    ));
  });

  const initialVariantId = sticky.dataset.currentVariantId;
  const initialVariant = stickyCartData && stickyCartData.variants && stickyCartData.variants[initialVariantId];
  if (initialVariant) renderStickyPrice(initialVariant);
  schedulePdpAppleCareSync();
  
  // Helper function to check if element is in viewport
  const isElementInViewport = (el) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
    );
  };

  // Helper function to check if element is scrolled ABOVE the viewport (user scrolled past it)
  const isElementAboveViewport = (el) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    // Element is above viewport when its bottom edge is above the top of the viewport
    return rect.bottom < 0;
  };

  const toggleSticky = () => {
    // Smart Bundle owns the selected items, total and purchase action while
    // it is visible. Avoid presenting a second product-only CTA beside it.
    if (isSmartBundleInView) {
      sticky.classList.add('sticky-cart--bundle-suppressed');
      sticky.classList.remove('active');
      return;
    }
    sticky.classList.remove('sticky-cart--bundle-suppressed');
    
    // On mobile, always show (CSS handles visibility)
    if (isMobileView()) {
      sticky.classList.add("active");
      return;
    }
    
    // On desktop, keep its normal scroll-driven state while the cart is open;
    // the orchestrator owns the shared hide/show animation for all chrome.
    if (document.querySelector('cart-drawer.active, cart-drawer.is-closing')) {
      sticky.classList.remove("active");
      return;
    }
    
    // Use only the PDP purchase CTA as the desktop scroll threshold. A global
    // support widget also uses `.wa-btn`, so a bare class lookup is unsafe here.
    const mainProductSection = document.querySelector('[id^="MainProduct-"]');
    
    // Find the buy button area - prioritize more specific elements
    let targetElement = null;
    if (mainProductSection) {
      targetElement = findAtcButton() ||
                     mainProductSection.querySelector('.soldout-wrap') ||
                     mainProductSection.querySelector('.product-form__buttons') ||
                     mainProductSection.querySelector('.product-form__submit') ||
                     mainProductSection.querySelector('product-form') ||
                     mainProductSection.querySelector('.buy-buttons');
    }
    
    // Fallback to global search if not found in main section
    if (!targetElement) {
      targetElement = document.querySelector('.soldout-wrap') ||
                     document.querySelector('.product-form__buttons') ||
                     document.querySelector('.product-form__submit');
    }
    
    // DESKTOP ONLY: Show sticky cart ONLY when user has scrolled PAST the buy button
    // (i.e., the buy button is ABOVE the viewport, not when it's below/not reached yet)
    const isTargetAboveViewport = targetElement ? isElementAboveViewport(targetElement) : false;
    
    // Show sticky only when target element is scrolled ABOVE the viewport (user scrolled past it)
    if (isTargetAboveViewport) {
      sticky.classList.add("active");
    } else {
      sticky.classList.remove("active");
    }
  };

  /* Apply initial state with no transition so the cart doesn't animate in
     while the skeleton is fading - otherwise the user sees a slide-up
     that looks like "shows then moves down". */
  sticky.classList.add("sticky-cart--no-transition");
  setupAtcObserver();
  toggleSticky();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      sticky.classList.remove("sticky-cart--no-transition");
    });
  });

  // Re-setup observer on resize (in case button position changed significantly)
  window.addEventListener("resize", () => {
    setupAtcObserver();
  });

  // A family swap can move the CTA before its observer/debounce fires. Resolve
  // visibility in the commit event, before the pending-state CSS is painted
  // away, so the old desktop bar cannot briefly reappear at the summary.
  ['linkedOptionsLoaded', 'linkedOptionsError'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      if (!document.querySelector('[data-family-model-selected]')) return;
      setupAtcObserver();
      toggleSticky();
    });
  });

  document.addEventListener('smart-bundle:visibility', (event) => {
    isSmartBundleInView = event.detail?.active === true;
    toggleSticky();
  });
  
  // Scroll listener as fallback for sold out products
  let scrollDebounceTimer = null;
  window.addEventListener("scroll", () => {
    if (scrollDebounceTimer) clearTimeout(scrollDebounceTimer);
    scrollDebounceTimer = setTimeout(() => {
      toggleSticky();
    }, 50);
  }, { passive: true });
  
  // ========================================
  // SMOOTH OVERSCROLL EXPAND (Mobile Only)
  // Pure CSS transitions - no JS animation loop
  // ========================================
  
  const SCALE_MAX = 1.18;        // Maximum 18% bigger
  const MAX_OVERSCROLL = 100;    // Pixels needed for max scale
  
  let isOverscrolling = false;
  let touchStartY = 0;
  let lastScale = 1;
  
  // Get the active button
  function getActiveButton() {
    const atcBtn = document.getElementById('sticky-cart-btn');
    const waBtn = document.getElementById('sticky-cart-wa-btn');
    if (atcBtn && atcBtn.style.display !== 'none') return atcBtn;
    if (waBtn && waBtn.style.display !== 'none') return waBtn;
    return atcBtn || waBtn;
  }
  
  // Smooth easing
  function easeOut(x) {
    return 1 - Math.pow(1 - x, 2.5);
  }
  
  // Calculate scale from overscroll
  function getScale(overscrollPx) {
    if (overscrollPx <= 0) return 1;
    const progress = Math.min(overscrollPx / MAX_OVERSCROLL, 1);
    return 1 + (SCALE_MAX - 1) * easeOut(progress);
  }
  
  // Apply scale (CSS handles smooth transition)
  function setScale(scale) {
    const btn = getActiveButton();
    if (!btn) return;
    
    // Avoid tiny updates that cause jitter
    if (Math.abs(scale - lastScale) < 0.005) return;
    lastScale = scale;
    
    const glow = (scale - 1) / (SCALE_MAX - 1);
    btn.style.setProperty('--btn-scale', scale.toFixed(3));
    btn.style.setProperty('--glow-intensity', glow.toFixed(3));
    
    if (scale > 1.005) {
      btn.classList.add('overscroll-active');
      btn.classList.remove('overscroll-release');
    }
  }
  
  // Reset to normal
  function resetScale() {
    const btn = getActiveButton();
    if (!btn) return;
    
    btn.classList.add('overscroll-release');
    btn.style.setProperty('--btn-scale', '1');
    btn.style.setProperty('--glow-intensity', '0');
    
    setTimeout(() => {
      btn.classList.remove('overscroll-active', 'overscroll-release');
      lastScale = 1;
      isOverscrolling = false;
    }, 500);
  }
  
  // Check if at page bottom
  function isAtBottom() {
    const scrollY = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    return scrollY >= maxScroll - 3;
  }
  
  // Touch handlers
  document.addEventListener('touchstart', (e) => {
    if (!isMobileView()) return;
    touchStartY = e.touches[0].clientY;
    
    const btn = getActiveButton();
    if (btn) btn.classList.remove('overscroll-release');
  }, { passive: true });
  
  document.addEventListener('touchmove', (e) => {
    if (!isMobileView()) return;
    
    const deltaY = touchStartY - e.touches[0].clientY;
    
    if (isAtBottom() && deltaY > 8) {
      isOverscrolling = true;
      setScale(getScale(deltaY));
    } else if (!isAtBottom() && isOverscrolling) {
      resetScale();
    }
  }, { passive: true });
  
  document.addEventListener('touchend', () => {
    if (!isMobileView()) return;
    if (isOverscrolling) resetScale();
  }, { passive: true });

  // Watch for cart drawer open/close
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      toggleSticky();
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Quantity controls with animations (variables declared earlier)
  if (qtyInput && qtyMinus && qtyPlus) {
    // Initialize button states
    updateQtyButtonStates(parseInt(qtyInput.value) || 1);
    
    // Use mousedown for more responsive feel
    qtyMinus.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const currentValue = parseInt(qtyInput.value) || 1;
      if (currentValue > minQty) {
        updateStickyQuantity(currentValue - 1);
      }
    });
    
    qtyPlus.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const currentValue = parseInt(qtyInput.value) || 1;
      if (currentValue < maxQty) {
        updateStickyQuantity(currentValue + 1);
      }
    });
    
    // Also add touch events for mobile
    qtyMinus.addEventListener("touchend", (e) => {
      e.preventDefault();
      const currentValue = parseInt(qtyInput.value) || 1;
      if (currentValue > minQty) {
        updateStickyQuantity(currentValue - 1);
      }
    }, { passive: false });
    
    qtyPlus.addEventListener("touchend", (e) => {
      e.preventDefault();
      const currentValue = parseInt(qtyInput.value) || 1;
      if (currentValue < maxQty) {
        updateStickyQuantity(currentValue + 1);
      }
    }, { passive: false });
    
    // Sync from main form to sticky cart
    if (mainQtyInput) {
      mainQtyInput.addEventListener("change", () => {
        const val = parseInt(mainQtyInput.value) || 1;
        qtyInput.value = val;
        updateQtyButtonStates(val);
      });
    }
  }

  // Always set up click handler (even if initially disabled, user might change to available variant)
  {
    let isProcessing = false;
    let stickyCartTriggered = false; // Flag to track if sticky cart triggered the add
    
    // An idle PDP has no error notice. Creating the shell during startup
    // exposed an empty icon before its post-paint stylesheet arrived.
    let toast = null;
    let toastTimeout = null;

    function showToast(message) {
      if (!message) return;
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'sticky-cart__toast';
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-atomic', 'true');
        toast.innerHTML = `
          <span class="sticky-cart__toast-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
              <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round"/>
            </svg>
          </span>
          <span class="sticky-cart__toast-text"></span>
        `;
        document.body.appendChild(toast);
      }
      if (toastTimeout) clearTimeout(toastTimeout);
      toast.querySelector('.sticky-cart__toast-text').textContent = message;
      toast.classList.add('show');
      toastTimeout = setTimeout(() => {
        toast.classList.remove('show');
      }, 3000);
    }

    // Subscribe to cart events to show proper success/error states
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Note: Variant change handling is done above in updateStickyCartForVariant()
      // This subscription just resets processing/loading states
      document.addEventListener('alasil:purchase-updated', () => {
        // Reset processing state only (UI updates handled by updateStickyCartForVariant)
        isProcessing = false;
        stickyCartTriggered = false;
        stickyBtn.classList.remove('loading', 'error', 'success');
        // Don't unconditionally enable button - let updateStickyCartForVariant handle it
      });
      
      // Cart update handler
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        schedulePdpAppleCareSync();

        // If sticky cart triggered this add, show success
        if (stickyCartTriggered && event.source === 'product-form') {
          stickyBtn.classList.remove('loading');
          stickyBtn.classList.add('success');
          
          // Reset to normal after success animation
          setTimeout(() => {
            stickyBtn.classList.remove('success');
            // Only enable if current variant is available
            const currentVariantId = sticky.dataset.currentVariantId;
            const currentVariant = (stickyCartData && stickyCartData.variants && stickyCartData.variants[currentVariantId]);
            if (currentVariant && currentVariant.available) {
              stickyBtn.disabled = false;
            }
            isProcessing = false;
            stickyCartTriggered = false;
          }, 650);
        }
        
        // If cart was updated from elsewhere (e.g., item removed), reset error state
        if (event.source === 'cart-items' || event.source === 'cart-drawer') {
          // Reset any stuck error state on sticky cart
          stickyBtn.classList.remove('loading', 'error');
          // Only enable if current variant is available
          const currentVariantId = sticky.dataset.currentVariantId;
          const currentVariant = (stickyCartData && stickyCartData.variants && stickyCartData.variants[currentVariantId]);
          if (currentVariant && currentVariant.available) {
            stickyBtn.disabled = false;
          }
          isProcessing = false;
          stickyCartTriggered = false;
          
          // Also reset main add-to-cart button in case it's stuck
          if (atcButton) {
            atcButton.removeAttribute('aria-disabled');
            atcButton.disabled = false;
            atcButton.classList.remove('loading');
          }
        }
      });
      
      // Error handler - show error state when add to cart fails
      subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (stickyCartTriggered && event.source === 'product-form') {
          stickyBtn.classList.remove('loading');
          stickyBtn.classList.add('error');
          
          // Get error message
          let errorMsg = event.message || event.errors || 'Error';
          // Format common messages
          if (errorMsg.includes('Maximum') || errorMsg.includes('maximum')) {
            errorMsg = 'Maximum quantity reached!';
          } else if (errorMsg.includes('Only') || errorMsg.includes('only')) {
            const match = errorMsg.match(/only\s+(\d+)/i);
            if (match) {
              errorMsg = `Only ${match[1]} available!`;
            }
          } else if (errorMsg.includes('sold out') || errorMsg.includes('Sold out')) {
            errorMsg = 'Sold out!';
          } else if (errorMsg.includes('Network') || errorMsg.includes('network')) {
            errorMsg = 'Network error!';
          }
          
          // Show toast
          showToast(errorMsg);
          
          // Reset to normal after error animation
          setTimeout(() => {
            stickyBtn.classList.remove('error');
            // Only enable if current variant is available
            const currentVariantId = sticky.dataset.currentVariantId;
            const currentVariant = (stickyCartData && stickyCartData.variants && stickyCartData.variants[currentVariantId]);
            if (currentVariant && currentVariant.available) {
              stickyBtn.disabled = false;
            }
            isProcessing = false;
            stickyCartTriggered = false;
          }, 2000);
        }
      });
    }
    
    stickyBtn.addEventListener("click", (event) => {
      // CRITICAL: Check if click is on View Cart link or any cart-related link
      const viewCartLink = event.target.closest('.cart-footer__view-cart-link, [href*="/cart"], [href*="cart"]');
      if (viewCartLink) {
        // Allow View Cart link to work normally - don't interfere
        return;
      }
      
      // Don't process if button is disabled (sold out)
      if (stickyBtn.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      
      // Prevent multiple clicks
      if (isProcessing) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
      
      // Only trigger add to cart if the sticky cart is actually visible
      // This prevents the sticky cart action from firing when it's hidden
      if (!sticky.classList.contains("active")) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
      
      // Also verify the click target is actually the sticky cart button
      // This prevents accidental triggers from overlapping elements
      const clickedElement = event.target.closest("#sticky-cart-btn");
      if (!clickedElement || clickedElement !== stickyBtn) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
      
      // Prevent default and stop propagation
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Set processing flag and mark that sticky cart triggered this
      isProcessing = true;
      stickyCartTriggered = true;
      
      // Save button dimensions before loading to prevent size change
      const btnRect = stickyBtn.getBoundingClientRect();
      stickyBtn.style.setProperty('--sticky-btn-width', btnRect.width + 'px');
      stickyBtn.style.setProperty('--sticky-btn-height', btnRect.height + 'px');
      stickyBtn.style.minWidth = btnRect.width + 'px';
      stickyBtn.style.minHeight = btnRect.height + 'px';
      
      // Add loading state with animation
      stickyBtn.classList.add('loading');
      stickyBtn.disabled = true;
      
      // Submit in the same interaction turn. ProductForm owns concurrency;
      // an artificial delay only makes the CTA and drawer feel out of sync.
      try {
          // Re-find ATC button in case it was created after variant change
          const currentAtcButton = atcButton || document.querySelector('product-form.product-form button[type="submit"], form[data-type="add-to-cart-form"] button[type="submit"]');
          if (currentAtcButton) {
            // Reset main button state before submitting (in case it's stuck from previous error)
            currentAtcButton.removeAttribute('aria-disabled');
            currentAtcButton.disabled = false;
            currentAtcButton.classList.remove('loading');
            
            // Use form submit instead of button click to avoid event loop issues
            const form = currentAtcButton.closest('form');
            if (form) form.dataset.analyticsButtonLocation = 'sticky';
            if (form && form.requestSubmit) {
              // Use requestSubmit which is safer and doesn't trigger click events
              form.requestSubmit(currentAtcButton);
            } else if (form) {
              // Fallback: dispatch a submit event so product-form's JS handler runs.
              // Native form.submit() bypasses listeners → preventDefault never fires →
              // browser POSTs to /cart/add and follows the redirect to /cart page,
              // breaking the cart-drawer flow.
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            } else if (typeof currentAtcButton.click === 'function') {
              // Last resort: use click but with a flag to prevent loops
              if (!currentAtcButton.dataset.stickyTriggered) {
                currentAtcButton.dataset.stickyTriggered = 'true';
                currentAtcButton.click();
                // Remove flag after a delay
                setTimeout(() => {
                  delete currentAtcButton.dataset.stickyTriggered;
                }, 1000);
              }
            }
            
            if (form) delete form.dataset.analyticsButtonLocation;

            // Fallback timeout in case pub/sub events don't fire (safety net)
            setTimeout(() => {
              if (isProcessing && stickyCartTriggered) {
                stickyBtn.classList.remove('loading');
                // Only re-enable if current variant is available
                const currentVariantId = sticky.dataset.currentVariantId;
                const currentVariant = (stickyCartData && stickyCartData.variants && stickyCartData.variants[currentVariantId]);
                if (currentVariant && currentVariant.available) {
                  stickyBtn.disabled = false;
                }
                isProcessing = false;
                stickyCartTriggered = false;
              }
            }, 5000);
          }
      } catch (error) {
          console.error('Error triggering add to cart:', error);
          isProcessing = false;
          stickyCartTriggered = false;
          stickyBtn.classList.remove('loading');
          // Only re-enable if current variant is available
          const currentVariantId = sticky.dataset.currentVariantId;
          const currentVariant = (stickyCartData && stickyCartData.variants && stickyCartData.variants[currentVariantId]);
          if (currentVariant && currentVariant.available) {
            stickyBtn.disabled = false;
          }
      }
      
      return false;
    }, { once: false, passive: false, capture: false });
  }
  
  // Handle View Cart links - open cart drawer instead of navigating to cart page
  // BUT: Only for links outside cart drawer footer (e.g., sticky cart)
  document.addEventListener('click', (event) => {
    const target = event.target;
    const viewCartLink = target.closest('.cart-footer__view-cart-link, a[href*="/cart"]:not([href*="add"]):not([href*="change"])');
    
    // IMPORTANT: Don't intercept clicks on View Cart link inside cart drawer footer
    // Allow it to navigate normally to cart page
    if (viewCartLink && viewCartLink.closest('.drawer__footer, cart-drawer')) {
      // This is inside cart drawer footer - let it work normally
      return;
    }
    
    if (viewCartLink && !viewCartLink.closest('#sticky-cart')) {
      // Check if cart drawer exists and cart type is drawer
      const cartDrawer = document.querySelector('cart-drawer');
      const isDrawerMode = document.querySelector('cart-drawer') !== null;
      
      if (isDrawerMode && cartDrawer && typeof cartDrawer.open === 'function') {
        // Prevent default navigation
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Open cart drawer
        cartDrawer.open(viewCartLink);
        return false;
      }
      
      // If no drawer, allow normal navigation
      return true;
    }
  }, { passive: false, capture: true });
}

/* This controller is interaction-loaded on mobile PDPs. Support both the
   original deferred-script path and a dynamic script inserted after
   DOMContentLoaded; otherwise the late-loaded controller would never mount. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAlasilStickyCart, { once: true });
} else {
  initAlasilStickyCart();
}
